import React, { useEffect, useState } from 'react';
import Search from '../searchComponents/Search';
import DatahubAPI from '../../../api/DatahubAPI';
import SubscribeModal from '../../SubscribeModal';
import { Redirect } from 'react-router-dom';
import { Typography } from '@mui/material';
import { Player } from '@lottiefiles/react-lottie-player';
import PaymentsAPI from 'api/PaymentsAPI';
import { runAIEvaluationSingleEntity } from '../searchComponents/AIEvaluate';
import { includeFields } from 'utils/OSDataHelper';
import { Modal } from '@mui/material';
import EntityFilterOptions from '../filterOpts/EntFilterOpts';
import DateSelector from '../filters/DateSelector';
import { format } from 'date-fns';
import CasesAPI from 'api/CasesAPI';
import { useSnackbar } from 'notistack';
import pako from 'pako';
import { Buffer } from 'buffer';

interface IEntitiesProps {
  filters: any;
  setFilters: any;
  setShowFullRecord: any;
  showFilters: boolean;
  setShowFilters: any;
  cur_user: any;
  activeSub: any;
  userHasEntitySearch: boolean;
  matchedTeamWithStripe: any;
  inputs: any;
  setInputs: any;
  page: number;
  setPage: any;
  entityState: any;
  setEntityState: any;
  screeningCus: any;
}

const Entities: React.FC<IEntitiesProps> = ({ screeningCus, entityState, setEntityState, page, setPage, inputs, setInputs, matchedTeamWithStripe, activeSub, userHasEntitySearch, cur_user, setShowFullRecord, filters, setFilters }) => {
  const [ entityReturns, setEntityReturns ] = useState<any>({ isLoading: true, data: [] });
  const [ initialComplete, setInitialComplete ] = useState(false);
  const [ aiSums, setAiSums ] = useState<any>([]);
  const [ filterMode, setFilterMode ] = useState(false);
  const [ appliedFilter, setAppliedFilter ] = useState<any>({});
  const [ openDate, setOpenDate ] = useState(false);
  const [ submit, setSubmit ] = useState<any>({
    trigger: false,
    reason: ''
  });
  const [ entityFiltersTotal, setEntityFiltersTotal ] = useState<any>({ isLoading: true, data: 0 });
  const [ saving, setSaving ] = useState(false);

  const { enqueueSnackbar } = useSnackbar();
  const dt = new Date();
  const dtWithoutTz = new Date(dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000);
  const formatted_dt = format(dtWithoutTz, 'yyyy-MM-dd');

  // FILTER OPTIONS STATE
  const [ lensOpts, setLensOpts ] = useState<{
    isLoading: boolean;
    data: any;
  }>({ isLoading: true, data: [] });
  const [ countryOpts, setCountryOpts ] = useState<{
    isLoading: boolean;
    data: any;
  }>({ isLoading: true, data: [] });
  const [ agencyOpts, setAgencyOpts ] = useState<{
    isLoading: boolean;
    data: any;
  }>({ isLoading: true, data: [] });
  const [ listOpts, setListOpts ] = useState<{
    isLoading: boolean;
    data: any;
  }>({ isLoading: true, data: [] });

  const [ countOpts, setCountOpts ] = useState([]);
  const [ agOpts, setAgOpts ] = useState([]);

  if (!cur_user.selected_team) {
    return <Redirect to='/' />;
  }

  const handleClear = () => {
    setEntityState({
      fuzzy: false,
      date: null,
      dateArr: [],
      lenses: [],
      agencies: [],
      countries: [],
      lists: []
    });
    setSubmit({ reason: 'apply', trigger: !submit.trigger, location: 'Entity' });
    setAppliedFilter({});
  };

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEntityState({ ...entityState, fuzzy: event.target.checked });
  };

  const handleDateChange = (newValue: any) => {
    const arr: any = [ ...newValue ];
    if (newValue[0] !== null) {
      arr.forEach((dt: any, index: number) => {
        if (dt !== null) {
          const dtWithoutTz = new Date(dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000);
          const formatted_dt = format(dtWithoutTz, 'yyyy-MM-dd');
          arr[index] = formatted_dt;
        }
      });
      setEntityState({ ...entityState, date: newValue, dateRange: arr });
    } else {
      setEntityState({ ...entityState, date: null, dateRange: [] });
    }
  };

  // BITE VAULT TICKET
  const handleTicket = async(values: any) => {
    const new_case = {
      groupId: cur_user.selected_team.id,
      ...values.basics,
      ...values,
    };
    const resp = await CasesAPI.createCase({ newCase: new_case });
    if (resp?.success) {
      setSaving(false);
      enqueueSnackbar('Successfully created new case', { variant: 'success' });
    } else if (resp) {
      const error_msg = 'Error saving new case. Uploaded file(s) may be too large.';
      enqueueSnackbar(error_msg, { variant: 'error' });
    }
  };

  const compressData = (data: any) => {
    const stringifiedData = JSON.stringify(data);
    const compressed = pako.gzip(stringifiedData);
    return Buffer.from(compressed).toString('base64'); // Convert to base64 for storage or transmission
  };

  const createTicket = async(name: string) => {
    setSaving(true);
    const entFilterQuery = {
      lenses: entityState.lenses,
      countries: entityState.countries,
      agencies: entityState.agencies,
      lists: entityState.lists,
      entRes: entityState.fuzzy,
      filterDate: entityState.dateRange
    };

    const comFilterQuery = {
      lenses: [],
      countries: [],
      agencies: [],
      lists: [],
      hsCodeLists: [],
      sections: [],
      chapters: [],
      codes: [],
      entRes: false,
      filterDate: [],
    };

    const ownerQuery = {
      kc_id: cur_user.basics?.id,
      email: cur_user.basics?.email,
      firstName: cur_user.basics?.firstName,
      lastName: cur_user.basics?.lastName,
    };

    const query: any = {
      ticketName: name,
      lastUpdate: formatted_dt,
      entity: {
        primary: inputs.primary,
        country: inputs.country,
        address: inputs.address,
      },
      docType: 'Single Entry - People / Companies',
      entityFilter: entFilterQuery,
      commodityFilter: comFilterQuery,
      frequency: 'Once',
      sharedWith: [],
      activeFilter: '',
      selectedOpts: [],
      status: 'Complete',
      favorite: false,
      groupName: cur_user.selected_team.name,
      template: [],
      colMapping: [],
      activity: {
        user: {
          kc_id: cur_user.basics?.id,
          email: cur_user.basics?.email,
          firstName: cur_user.basics?.firstName,
          lastName: cur_user.basics?.lastName,
        },
        action:  'created monitor ticket',
        timeStamp: Date.now()
      },
      owner: ownerQuery
    };
    const extractSources = (docs: any): any[] => {
      return docs.map((doc: any) => doc._source);
    };
    const length = entityReturns.data[0].result.body.hits.total.value;

    const structuredObj = [ {
      dataSet: 'Entities',
      docs: extractSources(entityReturns.data[0].result.body.hits.hits),
      field: inputs.primary,
      hits: length,
      row: 1
    } ];


    const ticketQuery = {
      ...query,
      curTotal: length,
      curNew: 0,
      results: {
        allResults: compressData(structuredObj),
        allTotal: length,
        newResults: [],
        newTotal: 0,
        date: formatted_dt,
        docInfo: []
      },
    };
    handleTicket(ticketQuery);
  };


  // HANDLE CSV RESULTS WITH 200 RESULTS
  const getEntCSVResults = async(pageNum: number) => {
    const allResults: any = [];
    const query: any = {
      primary: inputs.primary ? inputs.primary : '',
      listCountry: entityState.agencies.length > 0 || entityState.lists.length > 0 ? [] : entityState.countries,
      agency: entityState.lists.length > 0 ? [] : entityState.agencies,
      listName: entityState.lists,
      dateRange: entityState.dateRange,
      pageNum: pageNum,
      agg: true,
      fuzziness: entityState.fuzzy ? 'AUTO' : 0,
      qty: 200,
    };
    const res = await DatahubAPI.entitySearch(query);
    if (res?.success) {
      allResults.push(res?.result);
    }
    return allResults;
  };

  // GET INITIAL RESULTS AND SET OPTIONS
  const initialAPICall = async() => {
    const tableQuery: any = {
      agg: false,
    };
    const tableRes = await DatahubAPI.entitySearch(tableQuery);
    if (tableRes?.success) {
      setEntityReturns({ isLoading: false, data: [ tableRes.result ] });
    }

    const aggQuery: any = {
      agg: true,
    };
    const aggRes = await DatahubAPI.entitySearch(aggQuery);
    if (aggRes?.success) {
      setEntityFiltersTotal({ isLoading: false, data: aggRes.result?.result?.body?.hits?.total?.value });

      setLensOpts({ isLoading: false, data: [ ...aggRes.result.result.body.aggregations.entityAggs.buckets ] });
      const countryBuckets: any = [];
      aggRes.result?.result?.body?.aggregations?.entityAggs?.buckets.map((bucket: any) => {
        countryBuckets.push(bucket.countryAgg.buckets);
      });

      setCountryOpts({ isLoading: false, data: countryBuckets.flat() });
      const agencyBuckets: any = [];
      aggRes.result?.result?.body?.aggregations?.entityAggs?.buckets.map((bucket: any) => {
        bucket.countryAgg.buckets.map((secondBucket: any) => {
          agencyBuckets.push(secondBucket.agencyAgg.buckets);
        });
      });

      setAgencyOpts({ isLoading: false, data: agencyBuckets.flat() });
      const listBuckets: any = [];
      aggRes.result?.result?.body?.aggregations?.entityAggs?.buckets.map((bucket: any) => {
        bucket.countryAgg.buckets.map((secondBucket: any) => {
          secondBucket.agencyAgg.buckets.map((thirdBucket: any) => {
            listBuckets.push(thirdBucket.listNameAgg.buckets);
          });
        });
      });

      setListOpts({ isLoading: false, data: listBuckets.flat() });
      if (entityState.lenses.length > 0) {
        setInitialComplete(true);
      }
    }
  };

  // HANDLE LENS CHANGE
  const handleLensChange = async() => {
    setLensOpts({ ...lensOpts, isLoading: true });
    setCountryOpts({ ...countryOpts, isLoading: true });
    setAgencyOpts({ ...agencyOpts, isLoading: true });
    setListOpts({ ...listOpts, isLoading: true });
    const query: any = {
      lens: entityState.lenses,
      updateDay: entityState.dateArr,
      agg: true,
    };
    const res = await DatahubAPI.entitySearch(query);
    if (res?.success && entityState.lenses.length) {
      const addedBuckets: any = [];
      res?.result?.result?.body?.aggregations?.entityAggs?.buckets.map((bucket: any) => {
        addedBuckets.push(bucket.countryAgg.buckets);
      });
      const selections = addedBuckets.flat().map((obj: any) => {
        return obj.key;
      });
      setEntityState({
        ...entityState,
        countries: selections
      });
      setCountOpts(selections);
    } else if (entityState.lenses.length === 0) {
      setEntityState({
        ...entityState,
        countries: [],
        agencies: [],
        lists: [],
      });
    }
    setSubmit({
      trigger: !submit.trigger,
      reason: 'Listing Country'
    });
  };

  // HANDLE COUNTRY CHANGE
  const handleCountryChange = async() => {
    setAgencyOpts({ ...agencyOpts, isLoading: true });
    setListOpts({ ...listOpts, isLoading: true });
    const query: any = {
      lens: entityState.lenses,
      listCountry: entityState.countries,
      updateDay: entityState.dateArr,
      agg: true,
    };
    const res = await DatahubAPI.entitySearch(query);
    if (res?.success && entityState.countries.length > 0) {
      const addedBuckets: any = [];
      res?.result?.result?.body?.aggregations?.entityAggs?.buckets.map((bucket: any) => {
        bucket.countryAgg.buckets.map((secondBucket: any) => {
          addedBuckets.push(secondBucket.agencyAgg.buckets);
        });
      });
      const selections = addedBuckets.flat().map((obj: any) => {
        return obj.key;
      });
      setEntityState({
        ...entityState,
        agencies: selections
      });
      setAgOpts(selections);
    } else if (entityState.countries.length === 0) {
      setEntityState({
        ...entityState,
        agencies: [],
        lists: [],
      });
    }
    setSubmit({
      trigger: !submit.trigger,
      reason: 'Agency'
    });
    setCountryOpts({ ...countryOpts, isLoading: false });
  };

  // HANDLE AGENCY CHANGE
  const handleAgencyChange = async() => {
    setListOpts({ ...listOpts, isLoading: true });
    const query: any = {
      lens: entityState.lenses,
      agency: entityState.agencies,
      updateDay: entityState.dateArr,
      agg: true,
    };
    const res = await DatahubAPI.entitySearch(query);
    if (res?.success && entityState.agencies.length > 0) {
      const addedBuckets: any = [];
      res?.result?.result?.body?.aggregations?.entityAggs?.buckets.map((bucket: any) => {
        bucket.countryAgg.buckets.map((secondBucket: any) => {
          secondBucket.agencyAgg.buckets.map((thirdBucket: any) => {
            addedBuckets.push(thirdBucket.listNameAgg.buckets);
          });
        });
      });
      const selections = addedBuckets.flat().map((obj: any) => {
        return obj.key;
      });
      setEntityState({
        ...entityState,
        lists: selections
      });
    } else if (entityState.agencies.length === 0) {
      setEntityState({
        ...entityState,
        lists: [],
      });
    }
    setSubmit({
      trigger: !submit.trigger,
      reason: 'List'
    });
    setAgencyOpts({ ...agencyOpts, isLoading: false });
  };

  // HANDLE LIST CHANGE
  const handleListChange = async() => {
    const query: any = {
      lens: entityState.lenses,
      listName: entityState.lists,
      updateDay: entityState.dateArr,
      agg: true,
    };
    const res = await DatahubAPI.entitySearch(query);
    if (res?.success) {
      setEntityFiltersTotal({ isLoading: false, data: res?.result?.result?.body?.hits?.total?.value });
    }
    setListOpts({ ...listOpts, isLoading: false });
  };

  const triggerMeter = async(): Promise<any> => {
    const res = await PaymentsAPI.updateMeter(
      {
        type: 'screening_people_meter'
      },
      screeningCus.data.id
    );
    if (res?.success) {
      return res?.result;
    }
  };

  // API CALL THAT TIES IN THE FILTERS AND THE INPUT
  // ONLY CALL THAT WILL AFFECT THE RESULTS TABLE
  const handleSubmit = async(pageNum: number) => {
    setEntityReturns({ isLoading: true, data: [] });
    setAiSums([]);
    const allResults: any = [];
    let total = 0;
    const aiSummaries: any = [];


    const query: any = {
      primary: inputs.primary,
      lens: entityState.lenses,
      listName: entityState.lists,
      dateRange: entityState.dateRange,
      pageNum: pageNum,
      fuzziness: entityState.fuzzy ? 'AUTO' : 0,
      agg: true
    };
    const res = await DatahubAPI.entitySearch(query);
    if (res?.success) {
      allResults.push(res?.result);
      total = total + res?.result?.result?.body?.hits?.total?.value;

      if (inputs.primary.length > 0) {
        const fields = [
          'Name of Entity',
          'Alternative Names',
          'Additional Remarks',
          'Entity Address',
          'Profile',
          'Entity Country',
          'Agency',
        ];
        const hits = res?.result?.result?.body?.hits?.hits;

        if (hits.length > 1000) {
          const ai_summary = {
            best_match: '',
            entity_name: inputs.primary,
            explanation: 'Your searched returned over 1,000 results. Please narrow down your search by adjusting your filters or providing a more specific value if you would like an Evaluation.',
            match_probability: '',
            risk: ''
          };
          aiSummaries.push(ai_summary);
        } else {
          const hit_list = hits.map((hit: any) => hit._source);
          // Run the AI evaluation on the hits
          const filtered = await includeFields(fields, hit_list);
          const ai_summary = await runAIEvaluationSingleEntity(
            inputs.primary,
            inputs.country,
            inputs.address,
            JSON.stringify(filtered),
          );
          aiSummaries.push(ai_summary);
        }
      }

      if (inputs.primary !== '') {
        triggerMeter();
      }
    }

    setEntityReturns({ isLoading: false, data: allResults });
    setAiSums(aiSummaries);
    if (entityState.lenses.length === 0 &&
      entityState.countries.length === 0 &&
      entityState.agencies.length === 0 &&
      entityState.lists.length === 0
    ) {
      setEntityFiltersTotal({ isLoading: false, data: total });
    }
  };


  const handleMultiPageChange = async(input: any, pageNum: number, i: number) => {
    const allResults: any = entityReturns.data;
    const query: any = {
      primary: input,
      lens: entityState.countries.length > 0 ||
        entityState.agencies.length > 0 ||
        entityState.lists.length > 0 ?
        [] : entityState.lenses,
      listCountry: entityState.agencies.length > 0 || entityState.lists.length > 0 ? [] : entityState.countries,
      agency: entityState.lists.length > 0 ? [] : entityState.agencies,
      listName: entityState.lists,
      dateRange: entityState.dateRange,
      pageNum: pageNum,
      fuzziness: entityState.fuzzy ? 'AUTO' : 0,
      agg: true
    };
    const res = await DatahubAPI.entitySearch(query);
    if (res?.success) {
      allResults[i] = res?.result;
    }
    setEntityReturns({ isLoading: false, data: allResults });
  };

  useEffect(() => {
    switch (submit.reason) {
    case 'Lens':
      handleLensChange();
      break;
    case 'Listing Country':
      handleCountryChange();
      break;
    case 'Agency':
      handleAgencyChange();
      break;
    case 'List':
      handleListChange();
      break;
    case 'apply':
      handleSubmit(page);
      break;
    default:
      initialAPICall();
    }
  }, [ submit ]);

  useEffect(() => {
    if (initialComplete) {
      handleLensChange();
      handleSubmit(page);
    }
  }, [ initialComplete ]);

  useEffect(() => {
    setPage(0);
  }, [ inputs ]);

  return (
    <div className='screening-body-container'>
      {activeSub && !userHasEntitySearch ? (
        <div className='no-license-modal-screening'>
          <Player
            autoplay
            loop
            src='https://lottie.host/3c23c1ad-7f71-4e3d-8f19-69154715dbdc/SdWWjCmU1J.json'
            style={{ width: '20%' }}
          >
          </Player>
          <Typography variant='h6' className='text-white'
            style={{
              fontSize: '20px',
              fontWeight: 700,
              lineHeight: '24px',
              letterSpacing: '0.15px'
            }}
          >
            You need an assigned license to access this module
          </Typography>
          <Typography variant='h6'
            style={{
              fontSize: '18px',
              fontWeight: 700,
              lineHeight: '24px',
              letterSpacing: '0.15px',
              marginTop: '20px',
              color: '#BDBEC1'
            }}
          >
            Visit Account &gt; Users &gt; to assign
            an available license to your user or contact your team admin
          </Typography>
        </div>
      ) : (
        !userHasEntitySearch ? (
          <SubscribeModal
            name='Screening'
            screening={true}
            description='Quickly search for high risk people, companies and products as well as cyber threat indicators.'
            price={25}
            curUser={cur_user}
            stripeTeam={matchedTeamWithStripe}
            activeSub={activeSub}
          />
        ) : <></>
      )}
      <Search
        cyberTab={undefined}
        handleTabSwitch={undefined}
        userHasSearch={userHasEntitySearch}
        setShowFullRecord={setShowFullRecord}
        type={'Entities'}
        handleSubmit={handleSubmit}
        inputs={inputs}
        setInputs={setInputs}
        results={entityReturns}
        page={page}
        setPage={setPage}
        cyberHeaders={[]}
        getCSVResults={getEntCSVResults}
        handleMultiPageChange={handleMultiPageChange}
        aiSums={aiSums}
        state={entityState}
        openFilters={() => setFilterMode(true)}
        handleClear={handleClear}
        handleOpenDate={() => setOpenDate(true)}
        handleSwitchChange={handleSwitchChange}
        createTicket={createTicket}
        saving={saving}
      />
      <Modal
        open={filterMode}
        onClose={() => setFilterMode(false)}
        sx={{ zIndex: 900 }}
      >
        <EntityFilterOptions
          inputs={inputs}
          entityFiltersTotal={entityFiltersTotal.data}
          setFilterMode={setFilterMode}
          lensOpts={lensOpts}
          submit={submit}
          setSubmit={setSubmit}
          countryOpts={countryOpts}
          agencyOpts={agencyOpts}
          listOpts={listOpts}
          entityState={entityState}
          setEntityState={setEntityState}
          appliedFilter={appliedFilter}
          setAppliedFilter={setAppliedFilter}
          handleClear={handleClear}
          countOpts={countOpts}
          agOpts={agOpts}
          filters={filters}
          setFilters={setFilters}
          cur_user={cur_user}
        />
      </Modal>
      <Modal
        open={openDate}
        onClose={() => setOpenDate(false)}
      >
        <DateSelector
          openDate={openDate}
          setOpenDate={setOpenDate}
          state={entityState}
          handleDateChange={handleDateChange}
          setSubmit={setSubmit}
          submit={submit}
        />
      </Modal>
    </div>
  );
};

export default Entities;
